import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useCurrentOrg } from '@/features/org/hooks/use-org';
import {
  getFilteredPartners,
  PartnerFilters,
  PartnerPopulated,
} from '@/features/partners/api/get-partners';
import { usePartnerHubFilterStore } from '@/features/partners/components/pages/partner-hub-page';

type Props = UseQueryOptions<PartnerPopulated[], unknown, PartnerPopulated[]>;

const partnersFilteredQueryKey = (orgId?: number, filters?: PartnerFilters) => [
  'partners',
  'filtered',
  orgId,
  filters,
];

export const usePartnersFiltered = (props?: Props) => {
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();
  const { roles, partnerIds, searchQuery, fromDate, toDate } =
    usePartnerHubFilterStore();

  const filters: PartnerFilters = {
    roles,
    partnerIds,
    searchQuery,
    dateFrom: fromDate,
    dateTo: toDate,
  };

  return useQuery({
    ...props,
    queryKey: partnersFilteredQueryKey(org?.id, filters),
    queryFn: async () => {
      if (isOrgLoading || !org) return [] as PartnerPopulated[];
      return await getFilteredPartners({ orgId: org.id, filters });
    },
    enabled: !isOrgLoading && !!org,
  });
};
